import React, { useState, useEffect } from "react";
import "./currentPlan.scss";

import starLight from "assets/images/organisationProfile/pricing/starLight.svg";
import starDark from "assets/images/organisationProfile/pricing/starDark.svg";
import useTheme from "hooks/observer";
import Button from "components/Button/index";
import useScreenMobile from "hooks/useScreen";

// Default plan details if not available in localStorage
const planDetails = [
  "100 GB storage",
  "2 GB file upload limit",
  "Email hosting for multiple domains",
  "SSL & at-rest encryption",
  "User management",
  "Version history",
  "Granular access and controls",
  "25,000 API calls per month"
];

const CurrentPlan = ({ setChangePlan }) => {
  const [planName, setPlanName] = useState("Basic");
  const [renewalDate, setRenewalDate] = useState("21/01/2025");
  const [planAmount, setPlanAmount] = useState(400);

  useEffect(() => {
    const storedPlanName = sessionStorage.getItem("plan");
    const storedRenewalDate = sessionStorage.getItem("expirydate");
    const storedPlanTier = sessionStorage.getItem("plan");

    // Update state with localStorage values if available
    if (storedPlanName) {
      // Capitalize the first letter of the plan name
      const capitalizedPlanName =
        storedPlanName.charAt(0).toUpperCase() + storedPlanName.slice(1);
      setPlanName(capitalizedPlanName);
    }

    if (storedRenewalDate) {
      // Format the date for display
      const formattedDate = new Date(storedRenewalDate)
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        })
        .replace(/\//g, "/");
      setRenewalDate(formattedDate);
    }

    // Set plan amount based on plan tier
    if (storedPlanTier) {
      switch (storedPlanTier.toLowerCase()) {
        case "free":
          setPlanAmount(0);
          break;
        case "basic":
          setPlanAmount(400);
          break;
        case "pro":
          setPlanAmount(700);
          break;
        default:
          // Keep default amount
          break;
      }
    }

    // if (storedPlanFeatures) {
    //   try {
    //     const parsedFeatures = JSON.parse(storedPlanFeatures);
    //     if (Array.isArray(parsedFeatures) && parsedFeatures.length > 0) {
    //       setPlanFeatures(parsedFeatures);
    //     }
    //   } catch (error) {
    //     console.error("Error parsing plan features:", error);
    //   }
    // }
  }, []);
  const handleChangePlan = () => {
    setChangePlan(true);
  };
  const theme = useTheme();
  const isMobile = useScreenMobile({ size: 992 });
  return (
    <div className=" container currentPlanContainer">
      <div className="currentPlan">Current Plan</div>
      <div className="planName">
        <h5 className="planHeading">{planName}</h5>
        <p className="planDetail">
          Your plan will automatically renew on {renewalDate}. You&apos;ll be
          charged
          <span className="amount"> ${planAmount}/month</span>
        </p>
      </div>
      <div className="feature">
        <div className=" featurePlan">Features</div>
        <div className="planDetailsContainer">
          {planDetails.map((item, index) => (
            <div key={index} className="planDetail">
              <p className="planDetails">
                <img src={theme == "light" ? starLight : starDark} alt="" />
                {item}
              </p>
            </div>
          ))}
        </div>
      </div>
      <Button
        width={isMobile ? "87%" : "139px"}
        title="Change Plan"
        type="white"
        onClick={handleChangePlan}
      />
    </div>
  );
};

export default CurrentPlan;
